import React from 'react';
import { Button, Card, Form, Input, notification } from 'antd';
import authApi, { useLoginMutation } from '../../../features/auth/authApi';
import { useNavigate } from 'react-router-dom';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ResetPasswordButton from '../actions/resetPasswordButton';
import courseApi from '../../../features/courses/coursesApi';
import { useAppDispatch } from '../../../hooks';
import { isTeacher } from '../../../helpers/permissions';

const LoginFormContainerStyle: React.CSSProperties = {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'min(500px, calc(100vw - 48px))',
};

const LoginPage = () => {
    const { t } = useTranslation();
    const [login, {}] = useLoginMutation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const handleLogin = (values) => {
        login(values)
            .unwrap()
            .then(async () => {
                dispatch(authApi.util.resetApiState());
                dispatch(courseApi.util.resetApiState());
                // Teachers land on their inbox; everyone else on their courses.
                try {
                    const profile = await dispatch(
                        authApi.endpoints.userProfile.initiate('userDetails')
                    ).unwrap();
                    navigate(
                        isTeacher(profile)
                            ? '/app/submission-inbox'
                            : '/app/courses'
                    );
                } catch {
                    navigate('/app/courses');
                }
            })
            .catch((err) => {
                notification.error({
                    message: t('login.error.header') as string,
                    description: t('login.error.subHeader') as string,
                });
            });
    };

    return (
        <Card style={LoginFormContainerStyle}>
            <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={handleLogin}
                autoComplete="off"
                layout="vertical"
                size="large"
            >
                <Form.Item
                    label=""
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: t('login.emailMissingWarning') as string,
                        },
                    ]}
                >
                    <Input
                        prefix={
                            <UserOutlined className="site-form-item-icon" />
                        }
                        placeholder={t('login.email') as string}
                    />
                </Form.Item>

                <Form.Item
                    label=""
                    style={{ width: '100%' }}
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: t('login.missingPasswordWarning') as string,
                        },
                    ]}
                >
                    <Input.Password
                        prefix={
                            <LockOutlined className="site-form-item-icon" />
                        }
                        placeholder={t('login.password') as string}
                    />
                </Form.Item>

                <Form.Item>
                    <Button
                        data-cy={'login-button'}
                        type="primary"
                        htmlType="submit"
                        block
                    >
                        {t('login.login')}
                    </Button>
                </Form.Item>
            </Form>
            <div style={{ width: '100%' }}>
                <ResetPasswordButton />
            </div>
        </Card>
    );
};

export default LoginPage;
